import { Context, createContext, useContext } from 'react'

import { Extension } from './DataGrid.types'

const allContext = new Map<string, Context<any>>()

export const useExtensions = (gridId: string) => {
  const context = allContext.get(gridId)
  if (!context) throw new Error(`No context found for grid "${gridId}"`)
  return useContext(context)
}

export function generateContext<RowType>(gridId: string, extensions: Extension<RowType>[]) {
  const existing = allContext.get(gridId)
  if (existing) return existing

  const context = createContext(extensions)
  allContext.set(gridId, context)
  return context
}

export const deleteContext = (gridId: string) => {
  allContext.delete(gridId)
}
